import { useState } from "react";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useTour } from "@reactour/tour";

import { makeStyles } from "@material-ui/core/styles";
import {
  Tooltip,
  Box,
  Divider,
  Menu,
  MenuItem,
  Typography,
  List,
  ListItem,
  Grid,
  IconButton,
} from "@material-ui/core";

import componentStyles from "assets/theme/components/dropdowns/user-dropdown.js";
import { Help } from "@mui/icons-material";

const useStyles = makeStyles(componentStyles);

export default function HelperDropdown() {
  const classes = useStyles();
  const { setCurrentStep } = useTour();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);

  const menuOptions = [
    {
      id: 1,
      name: "Lojista",
      path: "/admin/lojista-360",
    },
    {
      id: 2,
      name: "Relatório de Acompanhamento de Títulos",
      path: "/admin/relatorio-acompanhamento-titulos",
    },
    {
      id: 3,
      name: "Favoritar tela",
      path: "/home",
    },
  ];

  const handleHelperOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const handleRemoveStorage = (removeStep) => {
    setCurrentStep(1);
    if (removeStep?.includes("lojista-360")) {
      localStorage.removeItem("lojistaStep1");
      localStorage.removeItem("lojistaStep4");
    } else if (removeStep?.includes("relatorio-acompanhamento-titulos")) {
      localStorage.removeItem("relatorioStep1");
      localStorage.removeItem("relatorioStep4");
    } else if (removeStep?.includes("home")) {
      localStorage.setItem("openMenu", true);
      localStorage.removeItem("homeStep1");
      localStorage.removeItem("homeStep2");
    }
  };

  const menuId = "dropdowns-user-dropdown-id";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={openMenu}
      onClose={handleMenuClose}
      style={{ marginTop: 50 }}
    >
      <Typography variant="h5" component="h5">
        Qual menu você deseja conhecer?
      </Typography>
      <Divider />
      <PerfectScrollbar
        options={{ suppressScrollX: true, useBothWheelAxes: false }}
        className={classes.itemsList}
        style={{ maxHeight: 350 }}
      >
        <List style={{ marginRight: "1rem", padding: 0 }}>
          {menuOptions?.map((item) => {
            return (
              <ListItem
                key={item?.id}
                style={{
                  marginBottom: "-0.5rem",
                  padding: "0.5rem 0 0 1rem",
                }}
                button
                component={Link}
                to={item?.path}
                onClick={() => {
                  handleRemoveStorage(item.path);
                  handleMenuClose();
                }}
              >
                <Grid container alignItems="center">
                  <Box
                    display="flex!important"
                    alignItems="center!important"
                    component={MenuItem}
                  >
                    <Typography
                      variant="h5"
                      component="h5"
                      className={classes.typographyH4}
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span style={{ marginRight: "0.5rem" }}>&bull;</span>
                      {item?.name}
                    </Typography>
                  </Box>
                </Grid>
              </ListItem>
            );
          })}
        </List>
      </PerfectScrollbar>
    </Menu>
  );

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="diálogo de ajuda"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleHelperOpen}
      >
        <Tooltip title="Ajuda">
          <Help />
        </Tooltip>
      </IconButton>
      {renderMenu}
    </>
  );
}
